import React from 'react'
import { useState } from"react";
import DatePicker from"react-datepicker";
import"react-datepicker/dist/react-datepicker.css";


function Packages() {
 const [startDate, setStartDate] = useState(null);

 return (
 <div>
 <div className="container-fluid bg-primary py-5 mb-5 hero-header">
 <div className="container">

   <div className="row justify-content-center">
 <div className="col-lg-10 text-center">
 <h1 className="display-3 text-white animated slideInDown">
 Packages
 </h1>
 <nav aria-label="breadcrumb">
 <ol className="breadcrumb justify-content-center">
 <li className="breadcrumb-item">
 <a href="/">Home</a>
 </li>
 <li
 className="breadcrumb-item text-white active"
 aria-current="page"
 >
 Packages
 </li>
 </ol>
 </nav>
 </div>
 </div>
 </div>
 </div>
 {/* Package Start */}
 <div className="container-xxl py-5">
 <div className="container">
 <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
 <h6 className="section-title bg-white text-center text-primary px-3">
 Forfaits
 </h6>
 <h1 className="mb-5">Forfaits Exceptionnels</h1>
 </div>
 <div className="row g-4 justify-content-center">
 <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
 <div className="package-item">
 <div className="overflow-hidden">
 <img className="img-fluid" src="assets/img/package-1.jpg" alt="" />
 </div>
 <div className="d-flex border-bottom">
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-map-marker-alt text-primary me-2" />
 Thaïlande
 </small>
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-calendar-alt text-primary me-2" />3 jours
 </small>
 <small className="flex-fill text-center py-2">
 <i className="fa fa-user text-primary me-2" />2 Personnes
 </small>
 </div>
 <div className="text-center p-4">
 <h3 className="mb-0">149,00 </h3>
 <div className="mb-3">
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 </div>
 {/* <p>
 Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit
 diam amet diam eos
 </p>*/} 
 <div className="d-flex justify-content-center mb-2">
 <a
 href="#"
 className="btn btn-sm btn-primary px-3 border-end"
 style={{ borderRadius:"30px 0 0 30px" }}
 >
 Lire Plus
 </a>
 <a
 href="#"
 className="btn btn-sm btn-primary px-3"
 style={{ borderRadius:"0 30px 30px 0" }}
 >
 Réserver
 </a>
 </div>
 </div>
 </div>
 </div>
 <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
 <div className="package-item">
 <div className="overflow-hidden">
 <img className="img-fluid" src="assets/img/package-2.jpg" alt="" />
 </div>
 <div className="d-flex border-bottom">
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-map-marker-alt text-primary me-2" />
 Indonésie
 </small>
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-calendar-alt text-primary me-2" />3 jours
 </small>
 <small className="flex-fill text-center py-2">
 <i className="fa fa-user text-primary me-2" />2 Personnes
 </small>
 </div>
 <div className="text-center p-4">
 <h3 className="mb-0">139,00 </h3>
 <div className="mb-3">
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 </div>
 {/* <p>
 Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit
 diam amet diam eos
 </p>*/} 
 <div className="d-flex justify-content-center mb-2">
 <a
 href="#"
 className="btn btn-sm btn-primary px-3 border-end"
 style={{ borderRadius:"30px 0 0 30px" }}
 >
 Lire Plus
 </a>
 <a
 href="#"
 className="btn btn-sm btn-primary px-3"
 style={{ borderRadius:"0 30px 30px 0" }}
 >
 Réserver
 </a>
 </div>
 </div>
 </div>
 </div>
 <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
 <div className="package-item">
 <div className="overflow-hidden">
 <img className="img-fluid" src="assets/img/package-3.jpg" alt="" />
 </div>
 <div className="d-flex border-bottom">
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-map-marker-alt text-primary me-2" />
 Malaisie
 </small>
 <small className="flex-fill text-center border-end py-2">
 <i className="fa fa-calendar-alt text-primary me-2" />3 jours
 </small>
 <small className="flex-fill text-center py-2">
 <i className="fa fa-user text-primary me-2" />2 Personnes
 </small>
 </div>
 <div className="text-center p-4">
 <h3 className="mb-0">189,00 </h3>
 <div className="mb-3">
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 <small className="fa fa-star text-primary" />
 </div>
 {/* <p>
 Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit
 diam amet diam eos
 </p> */} 
 <div className="d-flex justify-content-center mb-2">
 <a
 href="#"
 className="btn btn-sm btn-primary px-3 border-end"
 style={{ borderRadius:"30px 0 0 30px" }}
 >
 Lire Plus
 </a>
 <a
 href="#"
 className="btn btn-sm btn-primary px-3"
 style={{ borderRadius:"0 30px 30px 0" }}
 >
 Réserver
 </a>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>
 {/* Package End */}
 {/* Booking Start */}
 <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
 <div className="container">
 <div className="booking p-5">
 <div className="row g-5 align-items-center">
 <div className="col-md-6 text-white">
 <h6 className="text-white text-uppercase">Réservation</h6>
 <h1 className="text-white mb-4">Réservation En Ligne</h1>
 <p className="mb-4">
 Où que vos rêves vous mènent, nous veillerons à ce que chaque détail soit parfait.
Découvrez des destinations exclusives, comparez les meilleurs hôtels et réservez en toute confiance — tout en un seul endroit.

 </p>
 <p className="mb-4">
 Commencez votre prochaine aventure aujourd'hui.
 </p>
 <a className="btn btn-outline-light py-3 px-5 mt-2" href="">
 Lire Plus
 </a>
 </div>
 <div className="col-md-6">
 <h1 className="text-white mb-4">Réserver Un Circuit</h1>
 <form>
 <div className="row g-3">
 <div className="col-md-6">
 <div className="form-floating">
 <input
 type="text"
 className="form-control bg-transparent"
 id="name"
 placeholder="Votre Nom"
 />
 <label htmlFor="name">Votre Nom</label>
 </div>
 </div>
 <div className="col-md-6">
 <div className="form-floating">
 <input
 type="email"
 className="form-control bg-transparent"
 id="email"
 placeholder="Votre Email"
 />
 <label htmlFor="email">Votre Email</label>
 </div>
 </div>
 <div className="col-md-6">
 <div className="form-floating">
 <input
 type="datetime-local"
 className="form-control bg-transparent"
 id="datetime"
 placeholder="Date & Heure"
 />
 <label htmlFor="datetime">Date &amp; Heure</label>
 </div>
</div>

 <div className="col-md-6">
 <div className="form-floating">
 <select
 className="form-select bg-transparent"
 id="select1"
 >
 <option value={1}>Destination 1</option>
 <option value={2}>Destination 2</option>
 <option value={3}>Destination 3</option>
 </select>
 <label htmlFor="select1">Destination</label>
 </div>
 </div>
 <div className="col-12">
 <div className="form-floating">
 <textarea
 className="form-control bg-transparent"
 placeholder="Demande Spéciale"
 id="message"
 style={{ height: 100 }}
 defaultValue={""}
 />
 <label htmlFor="message">Demande Spéciale</label>
 </div>
 </div>
 <div className="col-12">
 <button
 className="btn btn-outline-light w-100 py-3"
 type="submit"
 >
 Réserver Maintenant
 </button>
 </div>
 </div>
 </form>
 </div>
 </div>
 </div>
 </div>
 </div>
 {/* Booking Start */}
 {/* Process Start */}
 <div className="container-xxl py-5">
 <div className="container">
 <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
 <h6 className="section-title bg-white text-center text-primary px-3">
 Processus
 </h6>
 <h1 className="mb-5">Des étapes Faciles</h1>
 </div>
 <div className="row gy-5 gx-4 justify-content-center">
 <div
 className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
 data-wow-delay="0.1s"
 >
 <div className="position-relative border border-primary pt-5 pb-4 px-4">
 <div
 className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
 style={{ width: 100, height: 100 }}
 >
 <i className="fa fa-globe fa-3x text-white" />
 </div>
 <h5 className="mt-4">Choisissez Une Destination</h5>
 <hr className="w-25 mx-auto bg-primary mb-1" />
 <hr className="w-50 mx-auto bg-primary mt-0" />
 {/* <p className="mb-0">
 Tempor erat elitr rebum clita dolor diam ipsum sit diam amet
 diam eos erat ipsum et lorem et sit sed stet lorem sit
 </p>*/} 
 </div>
 </div>
 {/* <div
 className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
 data-wow-delay="0.3s"
 >
 <div className="position-relative border border-primary pt-5 pb-4 px-4">
 <div
 className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
 style={{ width: 100, height: 100 }}
 >
 <i className="fa fa-dollar-sign fa-3x text-white" />
 </div>
 <h5 className="mt-4">Payez En Ligne</h5>
 <hr className="w-25 mx-auto bg-primary mb-1" />
 <hr className="w-50 mx-auto bg-primary mt-0" />
 <p className="mb-0">
 Tempor erat elitr rebum clita dolor diam ipsum sit diam amet
 diam eos erat ipsum et lorem et sit sed stet lorem sit
 </p>
 </div>
 </div>*/}
 <div
 className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
 data-wow-delay="0.5s"
 >
 <div className="position-relative border border-primary pt-5 pb-4 px-4">
 <div
 className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
 style={{ width: 100, height: 100 }}
 >
 <i className="fa fa-plane fa-3x text-white" />
 </div>
 <h5 className="mt-4">Voyagez Aujourd'hui</h5>
 <hr className="w-25 mx-auto bg-primary mb-1" />
 <hr className="w-50 mx-auto bg-primary mt-0" />
 {/* <p className="mb-0">
 Tempor erat elitr rebum clita dolor diam ipsum sit diam amet
 diam eos erat ipsum et lorem et sit sed stet lorem sit
 </p> */} 
 </div>
 </div>
 </div>
 </div>
 </div>
 {/* Process Start */}
 </div>
 )
}

export default Packages